import React from 'react';
import { HorizontalContainer } from './FlexboxContainer.js';
import { ProductCard } from './ProductCard.js';
import { combineClassNames } from '../util/css/classNames.js';
import style from './ProductList.scss';
export const ProductList = ({ products, className, cardsPerRow, twoColumnsTabletView }) => (React.createElement(HorizontalContainer, { verticalAlign: "stretch", wrap: true, className: combineClassNames(style.productList, className), "data-pw": "productList" }, renderCards(products, cardsPerRow, twoColumnsTabletView)));
function renderCards(cards, cardsPerRow, twoColumnTabletView) {
    return cards.map((card) => (React.createElement(ProductCard, { card: card, cardCount: cardsPerRow || cards.length, twoColumnsTabletView: twoColumnTabletView, key: card.id })));
}
